import { IAuth0Error, ILoginPayload } from '../interfaces';
import { removeProtocol } from './urlUtil';
import config from '../config';
import errors from '../errors';

/**
 *
 * @param payload ILoginPayload
 */
const auth0Config = 'auth0Config';

const getResponseType = () => {
  let responseType = window[auth0Config].extraParams.response_type;
  if (!responseType) {
    responseType = window[auth0Config].extraParams.type;
  }
  return responseType;
};

const getWebAuthParams = () => {
  const params = {
    domain: removeProtocol(window[auth0Config].authorizationServer.url),
    clientID: window[auth0Config].clientID,
    redirectUri: window[auth0Config].callbackURL,
    responseType: getResponseType(),
    ...window[auth0Config].internalOptions,
  };

  params.overrides = {
    __tenant: window[auth0Config].auth0Tenant,
    __token_issuer: window[auth0Config].authorizationServer.issuer,
  };

  return params;
};

export const authenticate = (payload: ILoginPayload) => {
  return new Promise((resolve, reject) => {
    try {
      const timeout = setTimeout(() => {
        reject(errors.AUTH0_TIMEOUT.errorCode);
      }, config.requestTimeoutMs);

      new auth0.WebAuth(getWebAuthParams()).login(
        {
          realm: 'MyAccountUsers',
          username: payload.username,
          rememberMe: payload.rememberMe,
          password: payload.password,
        },
        (error?: IAuth0Error) => {
          clearTimeout(timeout);
          if (error) {
            reject(error.code || 'generic_error');
          } else {
            resolve();
          }
        },
      );
    } catch (error) {
      reject(error);
    }
  });
};

export default {
  authenticate,
};
